import { createSelector } from 'reselect';
import { createHasScopeSelector } from 'EmailEditorUI/redux/selectors/AuthSelectors';
import { getIsLocalTime, getIsAbTest, getIsBatchEmail, getIsRssEmailType, getIsBlogEmail
// @ts-expect-error module not yet migrated
} from 'EmailEditorUI/redux/selectors/EmailSelectors';
export const getHasEmailThrottleSendScope = createHasScopeSelector('stagger-marketing-emails');
export const getHasEmailThrottleSendSpeedAccess = createSelector([getHasEmailThrottleSendScope, getIsLocalTime, getIsBatchEmail, getIsAbTest, getIsRssEmailType, getIsBlogEmail], (hasEmailThrottleSendScope, isLocalTime, isBatchEmail, isAbTest, isRSSEmail, isBlogEmail) => {
  return hasEmailThrottleSendScope && (isBatchEmail || isAbTest || isRSSEmail || isBlogEmail || isLocalTime);
});